module.exports = __webpack_public_path__ + "img/jingya.2569d65a.png";